<template>
  <BTooltip
    placement="top"
    width="200"
    trigger="hover"
    :content="content"
  >
    <BIcon
      class="ml-50"
      size="small"
      type="gray"
    >
      help
    </BIcon>
    <template #content>
      <slot />
    </template>
  </BTooltip>
</template>

<script lang="ts" setup>
type TProps = {
  content?: string;
};

defineProps<TProps>();
</script>
